import type { FlattenedSectionProps } from "../../../../../components/Questionnaire/Section";
import type { PartialQuestionOrGroup } from "../../../../../components/Questionnaire/Section/Question/types";
import type { QuestionnaireState } from "../../../types";
import { flattenQuestions } from "../groups/flattenQuestions";
import { filterAndAppendQuestions } from "./filterAndAppendQuestions";
import { updateChangedQuestionsList } from "./updateChangedQuestionsList";

export const handleAppendQuestionsAction = (
  state: QuestionnaireState,
  payload: PartialQuestionOrGroup[], // questions or groups
): QuestionnaireState => {
  const {
    sections: sectionsFromState,
    currentSectionIndex,
    changedQuestions,
    visibility,
    answers,
    groups,
  } = state;
  const sections = sectionsFromState as unknown as FlattenedSectionProps[];
  const changes = changedQuestions || [];

  // Flatten the payload: convert groups to questions
  const flattenedResult = flattenQuestions({
    payload,
    answers,
    visibility,
    groups,
  });

  // Get all flattened question names (includes shadow + hidden group questions)
  const allFlattenedQuestionNames = flattenedResult.questions.map(q => q.name);

  // Update the changed questions list with all flattened questions
  // Visibility map handles which questions are shown vs hidden
  // Also get filtered question names for removing stale questions from the section
  const { updatedChangedQuestions, filteredQuestionNames } =
    updateChangedQuestionsList({
      currentChangedQuestions: changes,
      newQuestionNames: allFlattenedQuestionNames,
    });

  // Remove questions from edit section if they already exist, then append
  // This includes both shadow questions and their hidden group questions
  const updatedSections = sections.map((section, index) =>
    index === currentSectionIndex
      ? {
          ...section,
          questions: filterAndAppendQuestions({
            existingQuestions: section.questions,
            filteredQuestionNames,
            newQuestions: flattenedResult.questions,
            allNewQuestionNames: allFlattenedQuestionNames,
          }),
        }
      : section,
  );

  return {
    ...state,
    sections: updatedSections,
    changedQuestions: updatedChangedQuestions,
    visibility: flattenedResult.visibility,
    answers: flattenedResult.answers,
    groups: flattenedResult.groups,
  };
};
